import { Component, Input, OnInit } from '@angular/core';
import { NgbActiveModal, NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { ActivatedRoute, Router } from '@angular/router';
import { CustomProductsService } from 'src/app/modules/custom-landing/custom-products/custom-products.service';
import { TenderSelectProductsPlaceBidComponent } from '../tender-select-products-place-bid/tender-select-products-place-bid.component';
import moment from 'moment';
import { NgIf, NgFor, DecimalPipe, DatePipe } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { I18nModule } from '@spartacus/core';
@Component({
    selector: 'app-tender-select-products-confirm-bid',
    templateUrl: './tender-select-products-confirm-bid.component.html',
    styleUrls: ['./tender-select-products-confirm-bid.component.scss'],
    imports: [NgIf, NgFor, FormsModule, DecimalPipe, DatePipe, I18nModule]
})
export class TenderSelectProductsConfirmBidComponent implements OnInit {
  private modalRef: NgbModalRef;
  div1:boolean=true;
  activeTab = 'none';
  priceTab= 'none';
  COI: boolean =false;
  OpenNegotiation:boolean=true;
  @Input() quantity:any;
  @Input() parameter:any;
  @Input() multipleProduct: any;
  @Input() tabName: any;
  @Input() materialFixedPrice1: number;
  @Input() materialIndexPrice1: number;
  @Input() indexValue:any;
  @Input() finalQPFromDate:any;
  @Input() finalQPToDate;
  @Input() dischargePortshw:any;
  productInfo:any;
  priceVal: any;
tabValue:any;
disabledBtn = false;
  additionalTerms: any;
  requestParams: any;
  reqTenderEntries:any = [];
  combinedchildlist:any = [];
  dupData:any;
  enableLoader: boolean = false;
  confirmTxt: string = null;

  constructor(private customProductService: CustomProductsService,private router: Router ,public activeModal: NgbActiveModal,private Modal:NgbModal, 
    private customProductsService: CustomProductsService, private toastrService: ToastrService) { }
rangeName: any;
  ngOnInit(): void {
    this.customProductsService.getConfirmtxt().subscribe((txt)=>{
      this.confirmTxt = txt;
    })
  this.productInfo=this.parameter;
  console.log(this.parameter,'parameter')
  this.tabValue=this.tabName;
  if(this.multipleProduct.groupTenders){
    for(let a of this.multipleProduct.groupTenders){
      this.combinedchildlist.push(...a?.childList)
      this.multipleProduct.combinedchildlist=[...this.combinedchildlist,...this.multipleProduct.IndividualTenders]
    }
  }
    if(this.multipleProduct.groupTenders){
      this.multipleProduct.combinedchildlist.map((val)=>{
        console.log('value', val);
        
        if(val.materialIndexPrice1 || val.materialFixedPrice1 || val.relativePrice ||val.IndexPrice || val.FixedPrice || val.premiumDiscount){
          this.reqTenderEntries.push({
            "dischargePortDetails":val.isDischargePortUnrestricted==true?val.dischargePortDetails:'',
            "entryNumber": val.entryNumber,
           "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
            "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
              "pricingOptionsEnum": [
                  {
                    "pricingOptions": val.priceTab?val.priceTab:val.pricingOptionsEnum[0].pricingOptions,
                    "qpMultipleChoices": val.pricingOptionsEnum[0].qp
                  }
                ],
              "productCode":  val.productCode,
              "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
              "quantity": val.minimumQuantity && val.maximumQuantity?val.Quantity: val.quantityshw ? parseInt(val.quantityshw):val.quantity,
            //   [val.priceTab=='FIXED_PRICE'?'relativePrice':'premiumDiscount']: {
            //     "currencyIso": "USD",
            //     "value":val.priceTab=='FIXED_PRICE' && this.multipleProduct.commodityType=='IO' ||this.multipleProduct.commodityType=='CC' ? val.materialFixedPrice1 : val.materialIndexPrice1,
            //  },
            [this.multipleProduct.commodityType=='CN'?"rcPrice":((val.priceTab?val.priceTab:val.pricingOptionsEnum[0].pricingOptions)=='FIXED_PRICE')? 'relativePrice' : 'premiumDiscount']: {
              "currencyIso": "USD",
              "value":this.multipleProduct.commodityType=='CN'? (val.materialIndexPrice1?val.materialIndexPrice1: val.premiumDiscount):((val.priceTab?val.priceTab:val.pricingOptionsEnum[0].pricingOptions)=='FIXED_PRICE') ? (val.materialFixedPrice1?val.materialFixedPrice1:val.FixedPrice) : val.materialIndexPrice1?val.materialIndexPrice1:val.IndexPrice,
            },
            [this.multipleProduct.commodityType=='CN'?"tcPrice":'tcPrice']: {
              "currencyIso":"USD",
              "value": this.multipleProduct.commodityType=='CN'?val.materialFixedPrice1?val.materialFixedPrice1:val.relativePrice:'',
            }
            })
        }     
      }) 
    }else{
      this.parameter.map((val)=>{
        console.log('value', val);
          this.reqTenderEntries.push({
            "dischargePortDetails":val.isDischargePortUnrestricted==true?val.dischargePortshw:'',
            "entryNumber": val.entryNumber,
           "finalQPFromDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPFromDate:'',
            "finalQPToDate":val.isQuotationPeriodUnrestricted==true || val.isQPMultipleChoicesSelected == true?val.finalQPToDate:'',
              "pricingOptionsEnum": [
                  {
                    "pricingOptions": val.priceTab?val.priceTab:val.pricingOptionsEnum[0].pricingOptions,
                    "qpMultipleChoices": val.pricingOptionsEnum[0].qp
                  }
                ],
              "productCode":  val.productCode,
              "qpMultipleChoices": val.pricingOptionsEnum[0].qp,
              "quantity": val.minimumQuantity && val.maximumQuantity?val.Quantity:parseInt(val.quantityshw),
            [this.multipleProduct.commodityType=='CN'?"rcPrice":val.priceTab=='FIXED_PRICE'? 'relativePrice' : 'premiumDiscount']: {
              "currencyIso": "USD",
              "value":this.multipleProduct.commodityType=='CN'? (val.materialIndexPrice1?val.materialIndexPrice1: val.premiumDiscount):val.priceTab=='FIXED_PRICE' ? val.materialFixedPrice1 : val.materialIndexPrice1,
            },
            [this.multipleProduct.commodityType=='CN'?"tcPrice":'tcPrice']: {
              "currencyIso":"USD",
              "value": this.multipleProduct.commodityType=='CN'?val.relativePrice:val.relativePrice,
            }
            })
      })   
    }
  }  
  convertingDateOnly(dateString,timezone): any {
    if (dateString) {
      return moment.parseZone(dateString).utcOffset(timezone.timeZoneFormat).format('DD/MM/YYYY HH:mm');
      }else{
        return '';
      }  }
  backToPlacebid(): any{
    this.activeModal.close();
    const ModalRef = this.Modal.open(TenderSelectProductsPlaceBidComponent,{centered: true,size:'md'});
    this.indexValue = this.parameter.length-1;
      ModalRef.componentInstance.indexValue = this.indexValue;
      ModalRef.componentInstance.index=this.parameter;
    ModalRef.componentInstance.code=this.multipleProduct;
    ModalRef.componentInstance.indexDisabled=false;
    ModalRef.componentInstance.fixedDisabled=false;
    ModalRef.componentInstance.disabled=false;
    if(this.parameter[this.indexValue].pricingOptionsEnum.length==1){
    this.dupData=this.multipleProduct.tenderEntries.filter((x)=>x.productCode==this.parameter[this.indexValue].productCode && x.pricingOptionsEnum[0].pricingOptions==this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions)
    }
    for (let i = this.indexValue; i > 0; i--)
    {
      if(this.parameter[this.indexValue].pricingOptionsEnum.length!=1){
        this.dupData=this.multipleProduct.tenderEntries.filter((x)=>x.productCode==this.parameter[i].productCode && x.pricingOptionsEnum[0].pricingOptions==this.parameter[i].pricingOptionsEnum[0].pricingOptions)
      }
      if(this.dupData.length>1){
        for(let duplicateData of this.dupData){
          if(duplicateData.childList==undefined){
          if (duplicateData.productCode == this.parameter[i].productCode)
          {    
            if(this.tabValue=='FIXED_PRICE'){
              ModalRef.componentInstance.fixedDisabled=true;
              ModalRef.componentInstance.disabled=ModalRef.componentInstance.indexDisabled=false;
            }else if(this.tabValue=='INDEX_PRICE'){
              ModalRef.componentInstance.indexDisabled=true;
              ModalRef.componentInstance.disabled=ModalRef.componentInstance.fixedDisabled=false;
            }

              ModalRef.componentInstance.disabled=true;
          
          }
        }
        }
      }
 
      }

    if(this.parameter[this.indexValue].minimumQuantity && this.parameter[this.indexValue].maximumQuantity){ 
    ModalRef.componentInstance.quantity=this.parameter[this.indexValue].Quantity
     }
      if(this.productInfo){
        ModalRef.componentInstance.tabName = this.tabValue;
        if(this.multipleProduct.commodityType=='CN'){
          ModalRef.componentInstance.disabled=false;
          ModalRef.componentInstance.price=this.parameter[this.indexValue].relativePrice;
          ModalRef.componentInstance.indexPrice=this.parameter[this.indexValue].premiumDiscount;
        }
       if(this.productInfo[this.indexValue].pricingOptionsEnum.length>1 && this.multipleProduct.commodityType!='CN'){
        if(this.tabValue=='FIXED_PRICE'){
          ModalRef.componentInstance.price=this.parameter[this.indexValue].materialFixedPrice1;
          this.parameter[this.indexValue].pricingOptionsEnum.priceTab=this.tabName;

        }
          if(this.tabValue=='INDEX_PRICE' || this.tabValue=='LUMP_FIXED_PRICE'||this.tabValue=='FIXED_PREMIUM'){
           ModalRef.componentInstance.indexPrice=this.parameter[this.indexValue].materialIndexPrice1;
           this.parameter[this.indexValue].pricingOptionsEnum.priceTab=this.tabName;
           if(this.productInfo[this.indexValue].isQuotationPeriodUnrestricted==true){
            this.productInfo[this.indexValue].finalQPFromDate=this.finalQPFromDate
            this.productInfo[this.indexValue].finalQPToDate=this.finalQPToDate
         }
          }
      }
      if(this.productInfo[this.indexValue].pricingOptionsEnum[0]?.qp){
        ModalRef.componentInstance.defaultValue = this.productInfo[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description;
        if(this.productInfo[this.indexValue]?.pricingOptionsEnum[0]?.qp[0]?.description == 'Fixed QP'){
          ModalRef.componentInstance.displayFixedQPSection = true
        }else{
           ModalRef.componentInstance.displayFixedQPSection = false;
        }
      }
      if(this.productInfo[this.indexValue].pricingOptionsEnum.length==1 && this.multipleProduct.commodityType!='CN'){
        if(this.productInfo[this.indexValue].pricingOptionsEnum[0].pricingOptions=='FIXED_PRICE'){
          ModalRef.componentInstance.price=this.parameter[this.indexValue].materialFixedPrice1;
          this.parameter[this.indexValue].pricingOptionsEnum.priceTab= this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions
        }
        if(this.productInfo[this.indexValue].pricingOptionsEnum[0].pricingOptions=='INDEX_PRICE'
            ||this.productInfo[this.indexValue].pricingOptionsEnum[0].pricingOptions=='LUMP_FIXED_PRICE'
              ||this.productInfo[this.indexValue].pricingOptionsEnum[0].pricingOptions=='FIXED_PREMIUM'){
          ModalRef.componentInstance.indexPrice=this.parameter[this.indexValue].materialIndexPrice1;
          this.parameter[this.indexValue].pricingOptionsEnum.priceTab= this.parameter[this.indexValue].pricingOptionsEnum[0].pricingOptions
         if(this.parameter[this.indexValue].isQuotationPeriodUnrestricted==true){
           this.parameter[this.indexValue].finalQPFromDate=this.finalQPFromDate
          this.parameter[this.indexValue].finalQPToDate=this.finalQPToDate
        }
        }
      }
    }
    }
    submitBid(): any{
     for(let RC of  this.reqTenderEntries){
      if(this.parameter[this.indexValue].displayRCPriceConfig.displayRCPrice==false){
      delete RC.rcPrice
      }
      if(RC.qpMultipleChoices){
        if(RC.qpMultipleChoices[0]?.description!='Fixed QP'){
          delete RC.finalQPFromDate;
          delete RC.finalQPToDate;
        }
      }
     
     }
      if(this.multipleProduct.commodityType=='IO'){
        delete this.reqTenderEntries.quantity
      }
      if(this.parameter[this.indexValue].isQuotationPeriodUnrestricted==false){
        delete this.reqTenderEntries.finalQPFromDate
        delete this.reqTenderEntries.finalQPToDate
      }
      if(this.multipleProduct.commodityType=='IO' || this.multipleProduct.commodityType=='CC'){
        for(let IronCoal of this.reqTenderEntries){
        delete IronCoal.tcPrice
        delete IronCoal.rcPrice
        }
        if (this.multipleProduct.commodityType == 'IO') {
          for (let IO of this.reqTenderEntries) {
            if(IO.premiumDiscount){
              if (IO.premiumDiscount?.value == '' || IO.premiumDiscount?.value == undefined) {
                IO.premiumDiscount.value = 0;
              }
            }
          }
        }
      }
      if(this.multipleProduct.commodityType=='CN'){
        for(let concentrates of this.reqTenderEntries){
          delete concentrates.pricingOptionsEnum
          delete concentrates.finalQPFromDate
          delete concentrates.finalQPToDate
  
        }
      }
      if(this.multipleProduct.commodityType=='CA'){
        for(let entry of this.reqTenderEntries){
          if(entry.pricingOptionsEnum[0].pricingOptions=='FLOATING_PREMIUM'){
            delete entry.premiumDiscount
          }
        }
      }
      this.requestParams = {
        "quoteAction": "BID_PLACED",
        "tender": {
          "buyerRemarks": this.additionalTerms,   
          "quoteCode": this.multipleProduct.quoteCode,
          "tenderEntries": this.reqTenderEntries
        }
      }
      this.disabledBtn = true;
      console.log(this.requestParams,'req')
      this.enableLoader = true;
      this.customProductsService.submitTender(this.requestParams).subscribe(resp=>{
        if( resp.status === 'BID_PLACED'){
          this.enableLoader = false;
         // this.toastrService.show(resp.status);
          this.activeModal.close();
          this.customProductService.bidPlaced = true;
          this.router.navigate([`/quotes/myquotes`]);
        }else{
          this.enableLoader = false;
          this.toastrService.show(resp.status?resp.status:"Sorry something went wrong!");
        }
      },
      err=>{
        console.log("err",err);this.activeModal.close();
        this.toastrService.show(err?.error.errors?err.error.errors[0].message:'Something went wrong while submitting the tender, please contact support team');
      })
    }
    homeLinkClick(value): any {
      this.customProductService.getHomeLinkActive(value);
    }
    getDate(date){
      if(date){
        var formateDate = new Date(date).getDate() + '/' + (new Date(date).getMonth() + 1) + '/' + new Date(date).getFullYear();
        return formateDate;
      }
      else{
        return '';
      }
    }
    formatQPDates(data){
      return this.customProductService.formatQPDates(data);
    }
    getPricingBasisBasedOnOption(pricingOption,description){
      return this.customProductService.getPricingBasisBasedOnOption(pricingOption,description)
    }
    getLabelofConfirmScreen(priceOptions,commodityType,page){
      return this.customProductService.getLabelofConfirmScreen(priceOptions,commodityType,page);
  
    }
    getPriceandSymbol(priceOptions,data,commodityType){
    let price = this.getPrice(data);
    return this.customProductService.getPriceandSymbol(priceOptions,price,commodityType);
    }
    getPrice(data){
      if(data?.pricingOptionsEnum[0].pricingOptions == 'INDEX_PRICE' || 
          data?.pricingOptionsEnum[0].pricingOptions == 'LUMP_FIXED_PRICE'||
            data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PREMIUM'){
        return data?.materialIndexPrice1;
      }
      else if( data?.pricingOptionsEnum[0].pricingOptions == 'FIXED_PRICE' ){
        return data?.materialFixedPrice1;
      }


    }
  }
 
